import isPlainObject from 'lodash-es/isPlainObject'

import { EMPTY_LIST } from '../../../constants/common'

export function isEntityTabAttributesEmpty(attributes) {
  return !attributes || Object.keys(attributes).length === 0
}

export function isEntityTabAttributeGroupValue(value) {
  return isPlainObject(value) || Array.isArray(value)
}

export function isEntityTabAttributeGroupEmpty(value) {
  return isPlainObject(value) && Object.keys(value).length === 0
}

export function getEntityTabAttributeNonEmptyEntries(attributes) {
  if (isEntityTabAttributesEmpty(attributes)) {
    return EMPTY_LIST
  }

  return Object.entries(attributes).filter(
    ([, value]) => !isEntityTabAttributeGroupEmpty(value)
  )
}

// Attribute keys come from the backend; unknown ones stay raw. `exists` because `t` returns the key path for a missing key.
export function getEntityTabAttributeLabel({ i18n, label, t }) {
  const key = `EntityTabAttributeLabels.${label}Key`

  return i18n.exists(key) ? t(key) : label
}

export function isEntityTabAttributeValueMissing(value) {
  return value === null
}

export function getEntityTabAttributeDisplayValue({ t, value }) {
  if (isEntityTabAttributeValueMissing(value)) {
    return t('EntityTabAttributes.ValueEmptyKey')
  }

  if (value === true) {
    return t('EntityTabAttributes.ValueYesKey')
  }

  if (value === false) {
    return t('EntityTabAttributes.ValueNoKey')
  }

  return value
}
